"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tryLogin = void 0;

var _Shared = require("../Shared");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * tryLogin will look for login credentials in path. If
 * credentials are found in path it will try to login with
 * those credentials
 * path: string
 * callback: function(path: string, callback(user: user, error: error))
 */
var tryLogin = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path, _callback) {
    var err, _err, parts, lp, userId, code, _iterator, _step, p, _err2;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (path) {
              _context.next = 7;
              break;
            }

            console.warn('tryLogin', 'path cannot be empty ignoring');
            err = new Error();
            err.name = 'login-failed';
            err.message = 'path cannot be empty';

            _callback(null, err);

            return _context.abrupt("return");

          case 7:
            if (!(_callback && !isFunction(_callback))) {
              _context.next = 14;
              break;
            }

            console.warn('tryLogin', 'callback must be a function ignoring');
            _err = new Error();
            _err.name = 'login-failed';
            _err.message = 'if callback is provided it must be a function';

            _callback(null, _err);

            return _context.abrupt("return");

          case 14:
            parts = path.split('/');
            lp = null;
            userId = null;
            code = null;
            _iterator = _createForOfIteratorHelper(parts);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                p = _step.value;

                if (lp === 'userid') {
                  userId = p;
                }

                if (lp === 'code') {
                  code = p;
                }

                if (lp === 'token') {
                  code = p;
                }

                lp = p;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            if (!(!userId || !code)) {
              _context.next = 26;
              break;
            }

            _err2 = new Error();
            _err2.name = 'login-failed';
            _err2.message = 'credentials not found';

            _callback(null, _err2);

            return _context.abrupt("return");

          case 26:
            _callback(true, false, 'credentials found');

            (0, _Shared.loginUser)({
              userId: userId,
              token: code,
              callback: function callback(user, error) {
                _callback(user, error);
              }
            });

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function tryLogin(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.tryLogin = tryLogin;

function isFunction(fun) {
  return fun && {}.toString.call(fun) === '[object Function]';
}